<template>
    <div class="page-table mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            Motor İşlemleri
        </div>
        <el-row :gutter="10">
            <el-col :lg="18" :md="18" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp">
                    <div>
                        <el-radio-group size="mini" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                        text-color="gray">
                            <el-radio-button label="1">
                                <i class="mdi mdi-circle-edit-outline mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='1'">Aktif Motor</label>
                                </transition>
                            </el-radio-button>
                            <el-radio-button label="0">
                                <i class="mdi mdi-circle-edit-outline  mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='0'">Pasif Motor</label>
                                </transition>
                            </el-radio-button>
                        </el-radio-group>
                    </div>
                    <el-table
                            :data="motorListesi"
                            style="width: 100%">
                        <el-table-column
                                label="Sıra"
                                type="index"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="motorAdi"
                                label="Motor"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                label="İşlem"
                                align="right"
                                width="auto">
                            <template slot-scope="scope">
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.duzenle")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                            type="text"
                                            class="buttonEdit"
                                            icon="el-icon-edit">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.firma.yonetici.liste.yoneticiaktif")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='0'"
                                            @click="durumChange(scope.row,scope.$index,motorListesi,1)"
                                            type="text"
                                            icon="mdi mdi-play mdi-24px">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.sil")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='1'"
                                            v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                            type="text"
                                            class="buttonDel"
                                            icon="mdi mdi-delete mdi-24px">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            layout="sizes,prev, pager, next, jumper, total"
                            :total="total"
                            @size-change="handleSizeChange"
                            @current-change="pageChange"
                            :page-sizes="[10, 20, 50, 100]"
                            :current-page.sync="page"
                            :next-click.sync="page"
                            :prev-click.sync="page"
                            @next-click="pageChange"
                            @prev-click="pageChange">
                    </el-pagination>
                </div>

            </el-col>
            <el-col :lg="6" :md="6" :sm="24" :xs="24">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                    <el-form status-icon :model="motorForm" :rules="rulesMotor" ref="motorForm" @submit.native.prevent="enter"
                             class="demo-ruleForm">
                        <div>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Motor Adı'
                                                  prop="motorAdi">:
                                        <el-input
                                                v-model="motorForm.motorAdi"
                                                placeholder='Motor Adı Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <el-row class="col-p">
                            <el-form-item>
                                <el-button v-if="btnVisible" size="small" v-on:click="motorTanimla('motorForm')"
                                           type="primary">
                                    Tanımla
                                </el-button>
                                <el-button v-else size="small" v-on:click="guncelleme('motorForm')" type="primary">
                                    Güncelle
                                </el-button>
                                <el-button v-if="!btnVisible" size="small" v-on:click="vazgec('motorForm')">
                                    Vazgeç
                                </el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["motorAdi"]}}" motorsını silmek istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="durumChange(selection,selectionIndex,motorListesi,0), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import motorService from '../../../../WSProvider/OpsiyonService'
    import notification from '../../../../notification'
    import JQuery from 'jquery';

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataEstasMil = "";
    export default {
        name: "MotorIslemleri",
        mounted() {
            this.motorCount();
            this.getMotorListesi();
        },
        data() {
            return {
                page: 0,
                sizes: 10,
                postPage: 0,
                total: null,
                selectIcon: '1',
                radio: '1',
                motorListesi: [],
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                dialogVisible: false,
                duzenleBtnVisible: true,
                VisibleA: false,
                linkVisible: false,
                linkChange: true,
                disabled: false,
                motorForm: {
                    motorAdi: '',
                },
                rulesMotor: {
                    motorAdi: [{
                        required: true,
                        message: "Lütfen Motor Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            handleSizeChange(val) {
                this.sizes = val;
                this.getMotorListesi();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.motorCount();
                this.getMotorListesi();
            },
            motorCount() {
                motorService.motorCount(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data);
                    }
                });
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getMotorListesi();
            },
            getMotorListesi() {
                motorService.motorList(this.selectIcon, this.postPage, this.sizes).then((response) => {
                    if (response.status === 200) {
                        this.motorListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                this.motorForm.motorAdi = scope.motorAdi;
                this.updateKodu = scope.motorKodu;
                this.btnVisible = false;
            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.btnVisible = true;
            },
            enter(){
                if(this.btnVisible){
                    this.motorTanimla('motorForm') ;
                }else this.guncelleme('motorForm')
            },
            motorTanimla(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        motorService.motorTanimlama(this.motorForm.motorAdi).then((response) => {
                            if (response.status === 200) {
                                this.motorListesi.push(response.data);
                                notification.Status('success', this, 'Motor başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir motor zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            guncelleme(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        motorService.motorGuncelle(this.updateKodu, this.motorForm.motorAdi).then((response) => {
                            if (response.status === 200) {
                                this.motorListesi.splice(this.selectionIndex, 1);
                                this.motorListesi.splice(this.selectionIndex, 0, {
                                    motorAdi: response.data.motorAdi,
                                    motorKodu: response.data.motorKodu
                                });
                                notification.Status('success', this, 'Motor başarıyla güncellendi...');
                                this.$refs[formName].resetFields();
                                this.btnVisible = true;
                            } else if (response.status === 200) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir motor zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            durumChange(selection, index, list,durum) {
                motorService.motorDurumGuncelle(selection.motorKodu,durum).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Motor başarıyla silindi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

</script>


<style scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }
    .el-radio-button--mini .el-radio-button__inner label {
        position: relative;
        bottom: 5px;
    }
</style>